// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditBlogDetails-space1-Qo4Uc {
	margin-bottom: 6px !important;
}

.EditBlogDetails-space2-MwzVE {
	margin-bottom: 12px !important;
}

.EditBlogDetails-space3-CQPUR {
	margin-bottom: 18px !important;
}

.EditBlogDetails-space4-oj1YH {
	margin-bottom: 24px !important;
}

.EditBlogDetails-space5-S4oCn {
	margin-bottom: 30px !important;
}

.EditBlogDetails-space6-YQGHp {
	margin-bottom: 36px !important;
}

.EditBlogDetails-space7-lRH3L {
	margin-bottom: 42px !important;
}

.EditBlogDetails-space8-vVesE {
	margin-bottom: 48px !important;
}

.EditBlogDetails-spaceTop1-IEP1u {
	margin-top: 6px !important;
}

.EditBlogDetails-spaceTop2-ybz7M {
	margin-top: 12px !important;
}

.EditBlogDetails-spaceTop3-BcPR_ {
	margin-top: 18px !important;
}

.EditBlogDetails-spaceTop4-kpTGQ {
	margin-top: 24px !important;
}

.EditBlogDetails-spaceTop5-trc4x {
	margin-top: 30px !important;
}

.EditBlogDetails-spaceTop6-cvHOj {
	margin-top: 36px !important;
}

.EditBlogDetails-spaceTop7-HMkeP {
	margin-top: 42px !important;
}

.EditBlogDetails-spaceTop8-wJEHu {
	margin-top: 48px !important;
}

.EditBlogDetails-noMargin-sTmk3 {
	margin: 0px !important;
}

.EditBlogDetails-padding1-BIcss {
	padding-bottom: 6px !important;
}

.EditBlogDetails-padding2-rw3No {
	padding-bottom: 12px !important;
}

.EditBlogDetails-padding3-sB2fW {
	padding-bottom: 18px !important;
}

.EditBlogDetails-padding4-cu5vq {
	padding-bottom: 24px !important;
}

.EditBlogDetails-padding5-Uorvz {
	padding-bottom: 30px !important;
}

.EditBlogDetails-padding6-v0JCQ {
	padding-bottom: 36px !important;
}

.EditBlogDetails-padding7-J3ZpO {
	padding-bottom: 42px !important;
}

.EditBlogDetails-paddingTop1-psuLC {
	padding-top: 6px !important;
}

.EditBlogDetails-paddingTop2-RwdPc {
	padding-top: 12px !important;
}

.EditBlogDetails-paddingTop3-xJq3u {
	padding-top: 18px !important;
}

.EditBlogDetails-paddingTop4-ASHJ_ {
	padding-top: 24px !important;
}

.EditBlogDetails-paddingTop5-oabcc {
	padding-top: 30px !important;
}

.EditBlogDetails-paddingTop6-g7qM5 {
	padding-top: 36px !important;
}

.EditBlogDetails-paddingTop7-xKUCO {
	padding-top: 42px !important;
}

.EditBlogDetails-noPadding-dlsIF {
	padding: 0px !important;
}

.EditBlogDetails-spaceMarginBottom0-pJ1vl {
	margin-bottom: 0;
}

.EditBlogDetails-textBold-ub_b7 {
	font-weight: 500 !important;
}

.EditBlogDetails-textBolder-hqnwx {
	font-weight: 700 !important;
}

.EditBlogDetails-textNormal-asP7D {
	font-weight: normal !important;
}

/*New Design Text Colors */

.EditBlogDetails-textDarkBlue-CXXg8 {
	color: rgb(20, 39, 94) !important;
}

.EditBlogDetails-textLightBlue-kCO3C {
	color: rgb(57, 87, 106) !important;
}

.EditBlogDetails-textLightSandleGreen-TV3Gn {
	color: rgb(76, 86, 41) !important;
}

.EditBlogDetails-textLightBrown-Chrrs {
	color: rgb(115, 79, 33) !important;
}

.EditBlogDetails-textMediumMaroon-shzxs {
	color: rgb(87, 37, 51) !important;
}

.EditBlogDetails-textBrown-SiHYH {
	color: rgb(160, 47, 24) !important;
}

.EditBlogDetails-textMaroon-yVMWU {
	color: rgb(155, 49, 67) !important;
}

.EditBlogDetails-textDarkBrown-hE8Ar {
	color: rgb(83, 18, 16) !important;
}

.EditBlogDetails-textMediumBrown-aWcmo {
	color: rgb(142, 28, 10) !important;
}

.EditBlogDetails-textSkyBlue-tC_rp {
	color: rgb(37, 117, 141) !important;
}

.EditBlogDetails-textGray-cA7_0 {
	color: rgb(77, 65, 51) !important;
}

.EditBlogDetails-errorMessage-xz8tJ {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.EditBlogDetails-userText-Wcvlh {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.EditBlogDetails-panelHeader-t1tq_ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.EditBlogDetails-exportSection-fe73z {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.EditBlogDetails-exportSectionGridSub-KuFMe {
	grid-template-columns: 50% 49% !important;
}

.EditBlogDetails-exportText-k75r9 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.EditBlogDetails-exportLinkImg-o0YIQ {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.EditBlogDetails-exportImg-kKXxG {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditBlogDetails-linkBtn-JRE9R {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.EditBlogDetails-table-WoHEI {
	display: table;
}

.EditBlogDetails-tableRow-CRSTb {
	display: table-row;
}

.EditBlogDetails-tableCell-R6EuU {
	display: table-cell;
	float: none;
}

.EditBlogDetails-formGroup-utgnx {
	margin-bottom: 6px;
}

.EditBlogDetails-marginTop0-mLM9E {
	margin-top: 0;
}

.EditBlogDetails-marginBottom20-rddkD {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.EditBlogDetails-bannerImageBg-AUcTt {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.EditBlogDetails-bannerDelete-hvI4G {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.EditBlogDetails-exportLink-Mr_Z9 {
	padding-top: 10px;
	padding-right: 10px;
}

.EditBlogDetails-seachContent-Sl7jy {
	padding-left: 0px;
	margin-bottom: 5px;
}

.EditBlogDetails-marginBottom9-gVgLJ {
	margin-bottom: 9px;
}

.EditBlogDetails-spaceTop52-yVbMx {
	margin-top: 52px;
}

.EditBlogDetails-profileViewInner-LNOzl {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.EditBlogDetails-profileViewMain-Ek5HA {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.EditBlogDetails-profileViewlabel-YSvM6 {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.EditBlogDetails-profileViewMainContent-ZI7zW {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.EditBlogDetails-reviewsFormStar-Y4MxQ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.EditBlogDetails-reviewsFormStar-Y4MxQ svg {
	cursor: pointer;
}

.EditBlogDetails-addLanguageText-nMTZ_ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.EditBlogDetails-exportSection-fe73z {
		grid-template-columns: 100%;
	}

	.EditBlogDetails-spaceTop52-yVbMx {
		margin-top: 18px;
	}

	.EditBlogDetails-exportText-k75r9 {
		float: none;
		margin-top: 12px;
	}

	.EditBlogDetails-exportSectionGridSub-KuFMe {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.EditBlogDetails-profileViewlabel-YSvM6 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditBlogDetails-profileViewMainContent-ZI7zW {
		width: 100%;
		text-align: center;
	}

	.EditBlogDetails-panelHeader-t1tq_ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.EditBlogDetails-addBlogCommonInputGrp-sJ7Go {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--primary-border);
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/EditBlogDetails/EditBlogDetails.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,mBAAmB;IACnB,oBAAoB;IACpB,8CAA8C;AAClD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.addBlogCommonInputGrp {\n    margin-bottom: 24px;\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--primary-border);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `EditBlogDetails-space1-Qo4Uc`,
	"space2": `EditBlogDetails-space2-MwzVE`,
	"space3": `EditBlogDetails-space3-CQPUR`,
	"space4": `EditBlogDetails-space4-oj1YH`,
	"space5": `EditBlogDetails-space5-S4oCn`,
	"space6": `EditBlogDetails-space6-YQGHp`,
	"space7": `EditBlogDetails-space7-lRH3L`,
	"space8": `EditBlogDetails-space8-vVesE`,
	"spaceTop1": `EditBlogDetails-spaceTop1-IEP1u`,
	"spaceTop2": `EditBlogDetails-spaceTop2-ybz7M`,
	"spaceTop3": `EditBlogDetails-spaceTop3-BcPR_`,
	"spaceTop4": `EditBlogDetails-spaceTop4-kpTGQ`,
	"spaceTop5": `EditBlogDetails-spaceTop5-trc4x`,
	"spaceTop6": `EditBlogDetails-spaceTop6-cvHOj`,
	"spaceTop7": `EditBlogDetails-spaceTop7-HMkeP`,
	"spaceTop8": `EditBlogDetails-spaceTop8-wJEHu`,
	"noMargin": `EditBlogDetails-noMargin-sTmk3`,
	"padding1": `EditBlogDetails-padding1-BIcss`,
	"padding2": `EditBlogDetails-padding2-rw3No`,
	"padding3": `EditBlogDetails-padding3-sB2fW`,
	"padding4": `EditBlogDetails-padding4-cu5vq`,
	"padding5": `EditBlogDetails-padding5-Uorvz`,
	"padding6": `EditBlogDetails-padding6-v0JCQ`,
	"padding7": `EditBlogDetails-padding7-J3ZpO`,
	"paddingTop1": `EditBlogDetails-paddingTop1-psuLC`,
	"paddingTop2": `EditBlogDetails-paddingTop2-RwdPc`,
	"paddingTop3": `EditBlogDetails-paddingTop3-xJq3u`,
	"paddingTop4": `EditBlogDetails-paddingTop4-ASHJ_`,
	"paddingTop5": `EditBlogDetails-paddingTop5-oabcc`,
	"paddingTop6": `EditBlogDetails-paddingTop6-g7qM5`,
	"paddingTop7": `EditBlogDetails-paddingTop7-xKUCO`,
	"noPadding": `EditBlogDetails-noPadding-dlsIF`,
	"spaceMarginBottom0": `EditBlogDetails-spaceMarginBottom0-pJ1vl`,
	"textBold": `EditBlogDetails-textBold-ub_b7`,
	"textBolder": `EditBlogDetails-textBolder-hqnwx`,
	"textNormal": `EditBlogDetails-textNormal-asP7D`,
	"textDarkBlue": `EditBlogDetails-textDarkBlue-CXXg8`,
	"textLightBlue": `EditBlogDetails-textLightBlue-kCO3C`,
	"textLightSandleGreen": `EditBlogDetails-textLightSandleGreen-TV3Gn`,
	"textLightBrown": `EditBlogDetails-textLightBrown-Chrrs`,
	"textMediumMaroon": `EditBlogDetails-textMediumMaroon-shzxs`,
	"textBrown": `EditBlogDetails-textBrown-SiHYH`,
	"textMaroon": `EditBlogDetails-textMaroon-yVMWU`,
	"textDarkBrown": `EditBlogDetails-textDarkBrown-hE8Ar`,
	"textMediumBrown": `EditBlogDetails-textMediumBrown-aWcmo`,
	"textSkyBlue": `EditBlogDetails-textSkyBlue-tC_rp`,
	"textGray": `EditBlogDetails-textGray-cA7_0`,
	"errorMessage": `EditBlogDetails-errorMessage-xz8tJ`,
	"userText": `EditBlogDetails-userText-Wcvlh`,
	"panelHeader": `EditBlogDetails-panelHeader-t1tq_`,
	"exportSection": `EditBlogDetails-exportSection-fe73z`,
	"exportSectionGridSub": `EditBlogDetails-exportSectionGridSub-KuFMe`,
	"exportText": `EditBlogDetails-exportText-k75r9`,
	"exportLinkImg": `EditBlogDetails-exportLinkImg-o0YIQ`,
	"exportImg": `EditBlogDetails-exportImg-kKXxG`,
	"linkBtn": `EditBlogDetails-linkBtn-JRE9R`,
	"table": `EditBlogDetails-table-WoHEI`,
	"tableRow": `EditBlogDetails-tableRow-CRSTb`,
	"tableCell": `EditBlogDetails-tableCell-R6EuU`,
	"formGroup": `EditBlogDetails-formGroup-utgnx`,
	"marginTop0": `EditBlogDetails-marginTop0-mLM9E`,
	"marginBottom20": `EditBlogDetails-marginBottom20-rddkD`,
	"bannerImageBg": `EditBlogDetails-bannerImageBg-AUcTt`,
	"bannerDelete": `EditBlogDetails-bannerDelete-hvI4G`,
	"exportLink": `EditBlogDetails-exportLink-Mr_Z9`,
	"seachContent": `EditBlogDetails-seachContent-Sl7jy`,
	"marginBottom9": `EditBlogDetails-marginBottom9-gVgLJ`,
	"spaceTop52": `EditBlogDetails-spaceTop52-yVbMx`,
	"profileViewInner": `EditBlogDetails-profileViewInner-LNOzl`,
	"profileViewMain": `EditBlogDetails-profileViewMain-Ek5HA`,
	"profileViewlabel": `EditBlogDetails-profileViewlabel-YSvM6`,
	"profileViewMainContent": `EditBlogDetails-profileViewMainContent-ZI7zW`,
	"reviewsFormStar": `EditBlogDetails-reviewsFormStar-Y4MxQ`,
	"addLanguageText": `EditBlogDetails-addLanguageText-nMTZ_`,
	"addBlogCommonInputGrp": `EditBlogDetails-addBlogCommonInputGrp-sJ7Go`
};
module.exports = ___CSS_LOADER_EXPORT___;
